<template>
  <FormResponsePageTemplate :intro="intro" />
</template>

<script>
import FormResponsePageTemplate from "../components/templates/FormResponsePageTemplate.vue";

export default {
  data: () => ({
    intro: "Sua mensagem foi enviada com sucesso.",
  }),
  components: { FormResponsePageTemplate },
};
</script>
